'use strict';

var $ = (typeof window !== "undefined" ? window.jQuery : typeof global !== "undefined" ? global.jQuery : null);

var notify = require('notify');
var triggerCustomEvent = require('trigger-custom-event');

var appDom = require('./app-dom');

var dom;
var panelType;
var isOpen = false;

var open = function(content, options) {

	var opts = $.extend({
		type: '',
		retainScrollPosition: false
	}, options);
	var scrollPosition = 0;

	isOpen = true;

	panelType = opts.type;

	if (opts.retainScrollPosition) {

		scrollPosition = scrollTop();

	}

	appDom.app.addClass('app--has-expanded-side-panel');

	dom.sidePanelDynamicContent.html(content);

	if (opts.retainScrollPosition) {

		scrollTop(scrollPosition);

	}

	triggerCustomEvent('side_panel_opened', {
		data: {
			panelType: panelType
		}
	});

};

var close = function(wasClosedByUser) {

	if (!isOpen) {

		return;

	}

	isOpen = false;

	notify.hide();

	appDom.app.removeClass('app--has-expanded-side-panel');

	triggerCustomEvent('side_panel_closed', {
		data: {
			panelType: panelType,
			closeTrigger: wasClosedByUser ? 'user' : 'auto'
		}
	});

	panelType = '';

};

var setupDom = function() {

	dom = {};
	dom.sidePanelDynamicContent = appDom.sidePanel.find('.side-panel__dynamic-content');
	dom.shield = appDom.app.find('.side-panel__shield');

};

var addEventHandlers = function() {

	appDom.sidePanel.on('touchmove', function(e) {

		var $sidePanelScroller = appDom.sidePanel.find('.side-panel__scroller');

		if ($sidePanelScroller[0].scrollHeight > $sidePanelScroller.outerHeight()) {

			// Stop the event from bubbling so the scroll blocking code in the image grid doesn't call preventDefault() and kill the scrolling of the side panel
			e.stopPropagation();

		}

	});

	appDom.document.on('click', '.js-close-side-panel', function(e) {

		e.preventDefault();
		close(true);

	});

	dom.shield.on('click', function(e) {

		e.preventDefault();
		close(true);

	});

};

var scrollTop = function(position) {

	if (typeof position !== 'undefined') {

		dom.sidePanelDynamicContent.find('.side-panel__scroller')[0].scrollTop = position;

	} else {

		return dom.sidePanelDynamicContent.find('.side-panel__scroller')[0].scrollTop;

	}

};

var init = function() {

	setupDom();
	addEventHandlers();

};

module.exports = {
	init: init,
	open: open,
	close: close,
	scrollTop: scrollTop
};
